import { useCallback, useState } from "react";
import { Button } from "components/UI/atoms";
import { FormCheckbox, FormInput } from "components/UI/molecules";
import { useLoginSubmit } from "./utils/useLoginSubmit";
import "./index.scss";
import { useCaptcha } from "./utils/useCaptcha";
import { useCaptchaV3 } from "hooks/useCaptchaV3";

const INITIAL_VALUES = {
  email: "",
  password: "",
  shouldRemember: false
};

export const LoginForm = () => {
  const [formValue, setFormValue] = useState(INITIAL_VALUES);
  const [shouldShowPassword, setShouldShowPassword] = useState(false);
  const { CaptchaComponent } = useCaptcha();
  const { captchaToken } = useCaptchaV3("login");

  const { isLoading, submitLogin } = useLoginSubmit();

  const togglePasswordVisibility = useCallback(() => {
    setShouldShowPassword((currentValue) => !currentValue);
  }, []);

  const handleFormValue = useCallback((newValue) => {
    setFormValue((currentValues) => ({ ...currentValues, ...newValue }));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await submitLogin({ ...formValue, captchaToken });
  };

  return (
    <form className="login-form">
      <FormInput
        id="email"
        name="user-email"
        label="Email"
        required
        type="email"
        placeholder="Email Address"
        inputClassName="login-form-item"
        value={formValue.email}
        onInput={(value) => handleFormValue({ email: value })}
      />
      <FormInput
        id="password"
        name="user-password"
        label="Password"
        required
        type={shouldShowPassword ? "text" : "password"}
        placeholder="Password"
        inputClassName="login-form-item"
        value={formValue.password}
        onInput={(value) => handleFormValue({ password: value })}
        endAdornment={
          <button
            type="button"
            className="password-visibility-button"
            onClick={togglePasswordVisibility}
          >
            {shouldShowPassword ? "Hide" : "Show"}
          </button>
        }
      />

      <FormCheckbox
        id="remember-me"
        name="user-remember-me"
        customClassName="remember-me-item"
        checked={formValue.shouldRemember}
        onChange={(value) => handleFormValue({ shouldRemember: value })}
        label="Remember me"
      />

      <Button
        customClassName="login-form-submit"
        type="submit"
        disabled={isLoading}
        onClick={handleSubmit}
      >
        Log In
      </Button>

      {CaptchaComponent}
    </form>
  );
};
